import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";
import store from "./store/index";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
    <Toaster
      toastOptions={{
        position: "top-center", // Position of the toast in the middle of the screen
        duration: 7000, // Duration in milliseconds
        style: {
          borderRadius: "1px 8px 8px 1px",
          background: "#fefefe",
          color: "#282c34",
        },
        // Success toast style
        success: {
          duration: 7000,
          style: {
            border: "1px solid #4CAF50",
            borderLeft: "5px solid #4CAF50",
            background: "#fefefe",
            color: "#4CAF50",
          },
          iconTheme: {
            primary: "#4CAF50",
            secondary: "#FFFFFF",
          },
        },
        // Error toast style
        error: {
          duration: 8000,
          style: {
            border: "1px solid #E57373",
            borderLeft: "5px solid #E57373",
            background: "#fefefe",
            color: "#E57373",
          },
          iconTheme: {
            primary: "#E57373",
            secondary: "#FFFFFF",
          },
        },
        // Default toast style
      }}
    />
  </Provider>
);

reportWebVitals();
